module.exports = require("escape-string-regexp");